import React from 'react';

import type { UseFormRegisterReturn } from 'react-hook-form';
import { Input, Prefix, Truncate, Unit, Wrapper } from './wrapper';

export type InputTextProps = React.DetailedHTMLProps<
  React.InputHTMLAttributes<HTMLInputElement>,
  HTMLInputElement
> & {
  type?: string;
  unit?: React.ReactNode;
  prefix?: string;
  hasError?: boolean;
  register?: UseFormRegisterReturn;
};

const InputText = React.forwardRef<HTMLInputElement, InputTextProps>(
  ({ type = 'text', prefix, unit, hasError, register, ...props }, ref) => (
    <Wrapper $hasError={hasError} $disabled={props.disabled}>
      {prefix && (
        <Prefix>
          <Truncate>{prefix}</Truncate>
        </Prefix>
      )}
      <Input type={type} {...props} ref={ref} {...register} />
      {unit && <Unit>{unit}</Unit>}
    </Wrapper>
  ),
);

export default InputText;
